export default __webpack_public_path__ + "static/media/current.642ff583.jpg";